import { render } from "./Overlay.vue?vue&type=template&id=124ed5b9&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=124ed5b9&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124ed5b9"]])

export default __exports__